import React from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import axios from 'axios';
import PropTypes from 'prop-types';
import preloader from 'preloader';
import noop from 'no-op';
import wait from '@jam3/wait';
import checkProps from '@jam3/react-check-extra-props';
import { device } from '@jam3/detect';
import sanitazer from '../../util/sanitizer';
import lockBodyScroll from '../../util/lock-body-scroll';

import settings from '../../data/settings';
// import backupData from '../../data/backup-data';

import './Preloader.scss';

// import { ReactComponent as LoaderIcon } from '../../assets/svg/loader.svg';

import animate from '../../util/gsap-animate';
import { setProgress, setReady, setSiteData } from '../../redux/modules/preloader';
import preloadAssets from '../../data/preload-assets';

class Preloader extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { code: '' };
    this.pairCode = debounce(this.pairCode, 200);
  }

  async componentDidMount() {
    await Promise.all([this.setTimer(), this.setLoader(), this.setData()]);
  }

  animateOut(onComplete) {
    return animate.to(this.container, 0.3, { autoAlpha: 0, onComplete });
  }

  async setTimer() {
    return await wait(this.props.minDisplayTime);
  }

  async setData() {
    const fetchedData = {};
    const pages = `${settings.cms}pages`;
    // const posts = `${settings.cms}posts`;
    const projects = `${settings.cms}projects?per_page=100`;
    const reqPages = axios.get(pages);
    const reqProjects = axios.get(projects);
    return await axios
      .all([reqPages, reqProjects])
      .then(
        axios.spread((...responses) => {
          const responsePages = responses[0];
          const responseProjects = responses[1];
          fetchedData.landing = responsePages.data.find(el => el.id === 7);
          fetchedData.experiments = responsePages.data.find(el => el.id === 8);
          fetchedData.about = responsePages.data.find(el => el.id === 9);
          fetchedData.review = responsePages.data.find(el => el.id === 10);
          fetchedData.contacts = responsePages.data.find(el => el.id === 11);
          fetchedData.video = responsePages.data.find(el => el.id === 12);
          fetchedData.projects = responseProjects.data;
          fetchedData.code = fetchedData.landing.cmb2.preloader.code;
          this.props.setSiteData(fetchedData);
        })
      )
      .catch(errors => {
        //   fetchedData.landing = backupData[0];
        //   this.props.setSiteData(fetchedData);
      });
  }

  setLoader() {
    return new Promise((resolve, reject) => {
      this.loader = preloader(this.props.options);
      this.props.assets.forEach(file => this.add(file));
      this.loader.on('progress', this.onProgress);
      this.loader.on('complete', () => this.onComplete(resolve));
      this.load();
    });
  }

  add(url, options = {}) {
    this.loader.add(url, options);
  }

  load() {
    this.loader.load();
  }

  onProgress = val => {
    this.progress.children[0].innerText = `${Math.round(val * 100)}%`;
    this.props.setProgress(val);
  };

  onComplete = done => {
    this.props.setProgress(1);
    animate.to(this.codeInput, 0.3, { className: 'Preloader__code--visible', delay: 0.3 });
    animate.to(this.title, 0.6, { autoAlpha: 1, delay: 1 });
    animate.to(this.codeInput, 0.6, { autoAlpha: 1, delay: 1.5 });
    animate.to(this.progress, 0.3, { autoAlpha: 0 });
    done();
  };

  setDone = async () => {
    await this.animateOut();
    if (device.isMobile) {
      lockBodyScroll.lock();
    }
    this.props.setReady(true);
  };

  handleCode = event => {
    this.setState({ code: event.target.value });
    this.pairCode();
  };

  pairCode() {
    const code = this.props.siteData.code ? this.props.siteData.code : '000';
    if (this.state.code === code) this.setDone();
  }

  render() {
    return (
      <section id="Preloader" ref={r => (this.container = r)}>
        <span className="Preloader__title" ref={r => (this.title = r)}>
          {sanitazer('MARINA BORS')}
        </span>
        <span className="Preloader__code" ref={r => (this.codeInput = r)}>
          <input type="text" value={this.state.code} onChange={this.handleCode} />
        </span>

        {/* <div className="Preloader__icon">
          <LoaderIcon className="loader-icon" />
        </div> */}
        <div className="Preloader__progress" ref={r => (this.progress = r)}>
          <span />
        </div>
      </section>
    );
  }
}

Preloader.propTypes = checkProps({
  className: PropTypes.string,
  assets: PropTypes.array.isRequired,
  setProgress: PropTypes.func.isRequired,
  setReady: PropTypes.func.isRequired,
  minDisplayTime: PropTypes.number,
  options: PropTypes.object,
  progress: PropTypes.number,
  transitionState: PropTypes.string,
  siteData: PropTypes.object.isRequired,
  setSiteData: PropTypes.func.isRequired
});

Preloader.defaultProps = {
  className: '',
  assets: [],
  minDisplayTime: 300, // in milliseconds
  options: {
    xhrImages: false,
    loadFullAudio: false,
    loadFullVideo: false,
    onProgress: noop,
    onComplete: noop
  }
};

const mapStateToProps = (state, ownProps) => {
  return {
    progress: state.preloader.progress,
    assets: preloadAssets,
    siteData: state.siteData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setProgress: val => dispatch(setProgress(val)),
    setReady: val => dispatch(setReady(val)),
    setSiteData: val => dispatch(setSiteData(val))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  undefined,
  { withRef: true }
)(Preloader);
